import React from "react";
import directorImage from "../assets/sun.png";
import logo from "../assets/logo.jpg";

const AboutSection = () => {
  return (
    <section
      id="about"
      className="bg-blue-900 min-h-screen py-8 sm:py-12 lg:py-16 flex items-center justify-center"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="bg-white sm:rounded-xl lg:rounded-2xl sm:shadow-lg lg:shadow-xl overflow-hidden">
          <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
            {/* Left Column - Image */}
            <div className="relative h-[240px] sm:h-[320px] lg:h-full">
              <img
                src={directorImage}
                alt="Managing Director"
                className="w-full h-full object-cover"
              />
              {/* Name card - Hidden on mobile, styled for tablet & desktop */}
              <div className="hidden sm:block absolute top-4 right-4 lg:top-6 lg:right-6">
                <div className="bg-orange-500 text-white px-4 py-2 lg:px-6 lg:py-3 rounded-lg shadow-lg">
                  <h3 className="text-base lg:text-xl font-medium">Sun Thet Tun</h3>
                  <p className="text-xs lg:text-sm font-light">Managing Director</p>
                </div>
              </div>
            </div>

            {/* Right Column - Content */}
            <div className="p-6 sm:p-8 lg:p-12 flex flex-col justify-center">
              <div className="space-y-4 sm:space-y-6 lg:space-y-8">
                <div>
                  <h4 className="text-orange-500 text-lg sm:text-xl font-medium tracking-wide mb-4 sm:mb-6">
                    TRUST · RELIABILITY · VALUE
                  </h4>

                  <div className="space-y-4 sm:space-y-0 sm:flex sm:items-center sm:gap-4">
                    <h2 className="text-blue-900 text-3xl sm:text-4xl lg:text-5xl font-bold">
                      Welcome To
                    </h2>
                    <img
                      src={logo}
                      alt="Sun Energy Logo"
                      className="h-12 sm:h-16 lg:h-20 w-auto"
                    />
                  </div>
                </div>

                <div className="space-y-4">
                  <p className="text-gray-700 text-base sm:text-lg lg:text-xl">
                    <span className="font-semibold text-blue-900">
                      Sun Energy
                    </span>
                    , part of the SKT Group since 2010, is the first solar panel
                    maker in the country.
                  </p>
                  <p className="text-gray-700 text-base sm:text-lg lg:text-xl">
                    Based in Yangon, Hlaing Township, we provide reliable,
                    cost-effective solar solutions for homes, businesses, and
                    communities nationwide.
                  </p>
                </div>

                {/* Learn More button - Hidden on mobile, shown on tablet & desktop */}
                <a
                  href="#team"
                  className="hidden sm:inline-block bg-blue-900 text-white px-6 py-2 lg:px-8 lg:py-3 rounded-lg 
                  hover:bg-blue-800 transition-colors duration-300 text-sm lg:text-base"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;